import Swiper from "swiper"
import { find } from "utils/dom"

import global from "../modules/global"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	const SwiperCampanhasDestaque = new Swiper(".swiper-campanhas-em-destaque",{
		slidesPerView: 1.1,
		spaceBetween: 12,
		centerInsufficientSlides: true,
		centeredSlidesBounds: true,
		navigation: {
        nextEl: ".controles-campanhas-em-destaque-swiper .swiper-button-next",
        prevEl: ".controles-campanhas-em-destaque-swiper .swiper-button-prev",
      },
		breakpoints:{
			767:{
				slidesPerView: 2.2,
				spaceBetween: 24,
			},
			993:{
				slidesPerView: 1.2,
				centerInsufficientSlides: false,
				centeredSlidesBounds: false,
			},
			1200:{
				slidesPerView: 2.4,
				centerInsufficientSlides: false,
				centeredSlidesBounds: false,
			},
			1600:{
				slidesPerView: 3,
			}
		}
	});

	const SwiperCampanhasAberto= new Swiper(".swiper-campanhas-em-aberto",{
		slidesPerView: 1.1,
		spaceBetween: 12,
		centerInsufficientSlides: true,
		centeredSlidesBounds: true,
		navigation: {
			nextEl: '.swiper-campanhas-em-aberto-prox',
			prevEl: '.swiper-campanhas-em-aberto-ant',
		},
		breakpoints:{
			600:{
				slidesPerView: 2.2,
				spaceBetween: 24,
			},
			767:{
				slidesPerView: 3.2,
			},
			1200:{
				slidesPerView: 4,
			}
		}
	});

}